import { Button } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'

interface ResetPermissionsProps {
  onTryAgain: () => void
}

export const ResetPermissions: FC<ResetPermissionsProps> = ({ onTryAgain }) => {
  const { t } = useTranslation('features-auth')

  return (
    <div className="h-full flex flex-col max-w-3xl mx-auto justify-start md:justify-center px-sm md:px-4xl pb-lg">
      <h1 className="typo-primary-2xl">{t('reset_permission.allow_permission')}</h1>

      <div className="mt-lg">
        <Button onClick={onTryAgain}>{t('reset_permission.try_again')}</Button>
      </div>
    </div>
  )
}
